import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_NETWORKS = '/networks';

export const GET_NETWORKS = 'GET_NETWORKS';
export const GET_NETWORKS_PENDING = 'GET_NETWORKS_PENDING';
export const GET_NETWORKS_FULFILLED = 'GET_NETWORKS_FULFILLED';
export const GET_NETWORKS_REJECTED = 'GET_NETWORKS_REJECTED';
export const CREATE_NETWORK = 'CREATE_NETWORK';
export const CREATE_NETWORK_FULFILLED = 'CREATE_NETWORK_FULFILLED';
export const CREATE_NETWORK_REJECTED = 'CREATE_NETWORK_REJECTED';

export const OPEN_NETWORK_CREATE_POPUP = 'OPEN_NETWORK_CREATE_POPUP';
export const CLOSE_NETWORK_CREATE_POPUP = 'CLOSE_NETWORK_CREATE_POPUP';
export const SET_NETWORK_LOADING = 'SET_NETWORK_LOADING';

export interface Network {
  id: string
  networkId: string
  ownIPAddress: string
  startPortNumber: string
  portNumberRange: string
  nodeName?: string
}

export interface NetworkState {
  entities: Network[]
  single: Network | null
  createdId: string | null
  ui: NetworkUIState
}

export type NetworkUIState = {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface OpenNetworkCreatePopupAction extends AnyAction {
  type: typeof OPEN_NETWORK_CREATE_POPUP
  payload: { network?: Network }
}

export interface CloseNetworkCreatePopupAction extends AnyAction {
  type: typeof CLOSE_NETWORK_CREATE_POPUP
}

export interface SetNetworkLoadingAction extends AnyAction {
  type: typeof SET_NETWORK_LOADING
  payload: { isLoading: boolean },
}

export interface GetNetworksAction extends AnyAction {
  type: typeof GET_NETWORKS
  payload: AxiosPromise<ServerResponse<Network>>
}

export interface GetNetworksPendingAction extends AnyAction {
  type: typeof GET_NETWORKS_PENDING
  payload: null
}

export interface GetNetworksFulfilledAction extends AnyAction {
  type: typeof GET_NETWORKS_FULFILLED
  payload: AxiosResponse<ServerResponse<Network>>
}

export interface CreateNetworkThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateNetworkAction extends AnyAction {
  type: typeof CREATE_NETWORK
  payload: AxiosPromise<ServerResponse<Network>>
}

export interface CreateNetworkFulfilledAction extends AnyAction {
  type: typeof CREATE_NETWORK_FULFILLED
  payload: AxiosResponse<ServerResponse<Network>>
}

export interface CreateNetworkRejectedAction extends AnyAction {
  type: typeof CREATE_NETWORK_REJECTED
  payload: AxiosResponse<ServerResponse<Network>>
}

export type NetworkActionTypes =
  OpenNetworkCreatePopupAction |
  CloseNetworkCreatePopupAction |
  SetNetworkLoadingAction |
  GetNetworksAction |
  GetNetworksPendingAction |
  GetNetworksFulfilledAction |
  CreateNetworkAction |
  CreateNetworkFulfilledAction |
  CreateNetworkRejectedAction;
